import { t, UUID, DateTimeISO } from '../common.ts';

export const AuditActorKind = t.Union([
  t.Literal('admin'),
  t.Literal('member'),
  t.Literal('partner'),
  t.Literal('system'),
  t.Literal('service'),
]);

export const AuditLogView = t.Object(
  {
    id: UUID,
    requestId: t.Union([t.String(), t.Null()]),
    actorKind: AuditActorKind,
    actorId: t.Union([UUID, t.Null()]),
    actorUsername: t.Union([t.String(), t.Null()]),
    action: t.String(),
    resource: t.String(),
    resourceId: t.Union([t.String(), t.Null()]),
    payloadBefore: t.Union([t.Record(t.String(), t.Unknown()), t.Null()]),
    payloadAfter: t.Union([t.Record(t.String(), t.Unknown()), t.Null()]),
    ipAddress: t.Union([t.String(), t.Null()]),
    userAgent: t.Union([t.String(), t.Null()]),
    createdAt: DateTimeISO,
  },
  { $id: 'AuditLogView' },
);

export const SecurityEventView = t.Object(
  {
    id: UUID,
    eventType: t.Union([
      t.Literal('login_success'),
      t.Literal('login_failed'),
      t.Literal('password_changed'),
      t.Literal('otp_failed'),
      t.Literal('brute_force'),
      t.Literal('ip_changed'),
      t.Literal('device_changed'),
      t.Literal('suspicious_activity'),
    ]),
    memberId: t.Union([UUID, t.Null()]),
    adminId: t.Union([UUID, t.Null()]),
    ipAddress: t.Union([t.String(), t.Null()]),
    userAgent: t.Union([t.String(), t.Null()]),
    detail: t.Record(t.String(), t.Unknown()),
    createdAt: DateTimeISO,
  },
  { $id: 'SecurityEventView' },
);

export const AuditSearchQuery = t.Object(
  {
    actorKind: t.Optional(AuditActorKind),
    actorId: t.Optional(UUID),
    action: t.Optional(t.String()),
    resource: t.Optional(t.String()),
    from: t.Optional(DateTimeISO),
    to: t.Optional(DateTimeISO),
    page: t.Integer({ minimum: 1, default: 1 }),
    pageSize: t.Integer({ minimum: 1, maximum: 1000, default: 50 }),
  },
  { $id: 'AuditSearchQuery' },
);
